import useSWR from 'hooks/useSWR';

export default id =>
  useSWR({
    url: `/v1/rpp_document_links/`,
    params: { company_id: id },
    swrOptions: { if: Boolean(id) }
  });
